import type { ChatToken as ChatTokenType } from "schemas/generated/chatMessage";

import * as React from "react";

import { AssetToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/AssetToken";
import { IntegrationObjectToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/IntegrationObjectToken";
import { IntegrationToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/IntegrationToken";
import { ProductToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/ProductToken";
import { SelectedElementToken } from "@agent-ui/features/chat/components/chat-elements/chat-tokens/SelectedElementToken";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

export default function ChatTokenComponent({
  token,
}: {
  token: ChatTokenType;
}): React.ReactNode {
  return exhaustiveSwitch(token)({
    product: ({ data }: Extract<ChatTokenType, { type: "product" }>) => (
      <ProductToken data={data} />
    ),
    asset: ({ data }: Extract<ChatTokenType, { type: "asset" }>) => (
      <AssetToken data={data} />
    ),
    integration: ({
      data,
    }: Extract<ChatTokenType, { type: "integration" }>) => (
      <IntegrationToken data={data} />
    ),
    "integration-object": ({
      data,
    }: Extract<ChatTokenType, { type: "integration-object" }>) => (
      <IntegrationObjectToken data={data} />
    ),
    "selected-element": ({
      data,
    }: Extract<ChatTokenType, { type: "selected-element" }>) => (
      <SelectedElementToken data={data} />
    ),
  });
}
